<template>
  <div class="commodity">
    <div class="title">
      <span style="cursor: pointer" @click="$router.go(-1)">商品中心</span>
      > <span>{{ optType == "add" ? "添加商品" : optType == "edit" ? "编辑商品" : "商品详情" }}</span>
    </div>
    <div class="main">
      <el-card>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="200px" class="demo-ruleForm scorll-auto">
          <div class="subtitle">
            <h4>基础信息</h4>
          </div>
          <el-form-item label="店铺名称：" prop="shop_name">
            <el-select v-model="ruleForm.shop_name" :disabled="optType == 'detail'" filterable placeholder="请选择店铺名称" :loading="loading" style="width: 400px" @change="shpoChange">
              <el-option v-for="item in shop_opt" :key="item.shop_id" :label="item.name" :value="item.shop_id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品标准名称：" prop="prolei">
            <el-select v-model="ruleForm.prolei" :disabled="optType == 'detail'" filterable @change="cateChange" placeholder="请选择商品标准名称" :loading="loading" style="width: 400px">
              <el-option v-for="item in customers" :key="item.standard_id" :label="item.name" :value="item.standard_id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌名称：">
            <el-select
              v-model="ruleForm.goods_brand_id"
              style="width: 400px"
              :disabled="optType == 'detail'"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词检索"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称：" prop="name">
            <el-input v-model="ruleForm.name" maxlength="80" show-word-limit style="width:400px;" :disabled="optType == 'detail'"></el-input>
          </el-form-item>

          <el-form-item label="商品主图：" prop="zhuFile">
            <el-upload
              style="display: inline-block"
              action="https://jsonplaceholder.typicode.com/posts/"
              :file-list="ruleForm.zhuFile"
              list-type="picture-card"
              :on-change="handleChange1"
              :auto-upload="false"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove1"
              :limit="1"
              :class="ruleForm.zhuFile.length == 1 ? 'mf' : ''"
              :disabled="optType == 'detail'"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span style="position: relative; top: 116px; left: 10px">{{ ruleForm.zhuFile.length + "/" + 1 }}</span>
          </el-form-item>
          <el-form-item>
            <el-link type="danger" :underline="false">图片尺寸建议600*600像素内，上传的图片默认自然排序</el-link>
          </el-form-item>
          <el-form-item label="商品轮播图：" prop="lbFile">
            <el-upload
              style="display: inline-block"
              action="https://jsonplaceholder.typicode.com/posts/"
              :file-list="ruleForm.lbFile"
              :multiple="true"
              list-type="picture-card"
              :on-change="handleChange2"
              :auto-upload="false"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove2"
              :limit="5"
              :class="ruleForm.img_detail.length == 5 ? 'mf' : ''"
              :disabled="optType == 'detail'"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span style="position: relative; top: 116px; left: 10px">{{ ruleForm.img_detail.length + "/" + 5 }}</span>
          </el-form-item>
          <el-form-item label="商品详情图：" prop="detailFile">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              :multiple="true"
              :file-list="ruleForm.detailFile"
              list-type="picture-card"
              :on-change="handleChange3"
              :auto-upload="false"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove3"
              :disabled="optType == 'detail'"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <!--  <el-form-item label="分类类型："
                        prop="region">
            <el-select v-model="ruleForm.region"
                       placeholder="请选择分类类型"
                       :disabled="optType == 'detail'"
                       style="width: 400px">
              <el-option label="虚拟商品(暂未开放，尽请期待)"
                         :disabled="true"
                         value="2001"></el-option>
              <el-option label="实物商品"
                         value="2000"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="商品参数：" required v-show="prepertyList.length">
            <div class="bg">
              <el-row :gutter="40">
                <template>
                  <el-col :span="12" v-for="(property, indexProperty) in prepertyList" :key="property.id">
                    <el-row :gutter="10">
                      <el-col :span="6"
                        ><label for="">{{ property.name }}</label></el-col
                      >
                      <el-col :span="18">
                        <PropertyUnit
                          :property_id="property.property_id"
                          :name="property.name"
                          :is_necessary="property.is_necessary"
                          :value="property.value"
                          :unit="property.unit"
                          :attribute="attribute"
                          :formAttribute="ruleForm.attribute"
                          :indexProperty="indexProperty"
                          :optType="optType"
                        ></PropertyUnit>
                      </el-col>
                    </el-row>
                  </el-col>
                </template>
              </el-row>
            </div>
          </el-form-item>
          <div class="subtitle">
            <h4>规格库存（SKU）</h4>
          </div>
          <!-- <el-form-item label="规格："
                        :required="true">
            <el-radio v-model="Spec"
                      label="1"
                      :disabled="optType == 'detail'">单规格</el-radio>
            <el-radio v-model="Spec"
                      label="2"
                      :disabled="optType == 'detail'">多规格</el-radio>
          </el-form-item> -->
          <!-- <el-form-item label="商品销售价："
                        prop="xsj">
            <el-input-number v-model="ruleForm.xsj"
                             :disabled="optType == 'detail'"
                             :min="0"
                             style="width: 250px; margin-right: 5px"
                             placeholder="请输入销售价(元)"></el-input-number>
          </el-form-item>
          <el-form-item label="商品市场价："
                        prop="scj">
            <el-input-number v-model="ruleForm.scj"
                             :disabled="optType == 'detail'"
                             :min="0"
                             style="width: 250px; margin-right: 5px"
                             placeholder="商品市场价(元)"></el-input-number>
          </el-form-item>
          <el-form-item 
            v-model="ruleForm.kc"
            prop="kc"
            label="库存："
          >
            <el-input-number 
              v-model="ruleForm.kc"
              :disabled="optType == 'detail'"
              :min="0"
              style="width: 250px; margin-right: 5px"
              placeholder="库存"
            ></el-input-number>
          </el-form-item> -->
          <el-form-item label="商品规格" prop="guigeList">
            <div class="guige">
              <el-select v-model="ggname" placeholder="请选择规格名" :disabled="optType == 'detail'">
                <el-option v-for="gui in Guigename" :key="gui.id" :label="gui.title" :value="gui.id"> </el-option>
              </el-select>

              <!-- <el-input v-if="insertggm"
                        :disabled="optType == 'detail'"
                        v-model="guititle"
                        placeholder="请输入规格名"
                        style="width: 200px; margin-left: 20px"
                        clearable
                        @clear="insertggm = false"></el-input>

              <el-button v-if="insertggm"
                         :disabled="optType == 'detail'"
                         @click="insertGgm"
                         type="primary"
                         style="margin-left: 8px">
                确认
              </el-button> -->

              <!-- <el-button type="primary"
                         :disabled="optType == 'detail'"
                         style="margin-left: 8px"
                         @click="insertggm = true">
                <i class="el-icon-plus"></i>
              </el-button> -->

              <el-input placeholder="请输入规格值" :disabled="optType == 'detail'" v-model="ggvalue" style="width: 200px; margin-left: 20px" clearable @keyup.enter.native="insertYI"></el-input>
              <el-button type="primary" :disabled="optType == 'detail'" style="margin-left: 8px" @click="insertYI">生成</el-button>
            </div>
            <div class="items" v-for="(item, index) in ruleForm.guigeList" :key="index" style="margin-top: 10px; background: #cccccc7a; padding: 10px; border-radius: 8px; box-sizing: border-box">
              <div class="top">
                <el-button type="warning">{{ getGuival(item.ggname) }}</el-button>
                <el-button @click="deleteYI(item)" :disabled="optType == 'detail'" style="margin-left: 8px" type="danger"><i class="el-icon-delete"></i></el-button>
              </div>
              <div class="yiji" style="margin-top: 10px">
                <span style="margin-left: 8px">规格值：</span>
                <el-button>{{ item.value }}</el-button>
                <el-select :disabled="item.gg2name != '' || item.gg2name === 0" v-model="item.gg2name" placeholder="请选择规格名" style="margin-left: 8px">
                  <el-option label="默认值" :value="0"></el-option>
                  <el-option :disabled="gui.id == item.ggname" v-for="gui in Guigename" :key="gui.id" :label="gui.title" :value="gui.id"></el-option>
                </el-select>
                <!-- <el-button v-if="item.gg2name!=''" @click="item.gg2name=''" type="primary" style="margin-left:10px;">取消</el-button> -->
                <el-input
                  v-if="item.gg2name != 0"
                  placeholder="请输入规格值"
                  v-model="item.gg2value"
                  :disabled="optType == 'detail'"
                  style="width: 200px; margin-left: 20px"
                  clearable
                  @keyup.enter.native="insertER(item)"
                ></el-input>
                <el-button type="primary" style="margin-left: 8px" :disabled="optType == 'detail'" @click="insertER(item)">生成</el-button>

                <div class="erji" v-for="(item2, index) in item.children2" :key="index" style="margin-top: 10px">
                  <div class="top" v-if="index == 0 && item.gg2name">
                    <el-button type="warning">{{ getGuival(item2.name) }}</el-button>
                    <el-button @click="deleteers(item)" :disabled="optType == 'detail'" style="margin-left: 8px" type="danger"><i class="el-icon-delete"></i></el-button>
                  </div>
                  <!--   -->
                  <div class="erjiConitem" style="margin-top: 10px">
                    <span style="margin-left: 8px">规格值：</span>
                    <el-button>{{ item2.value }}</el-button>
                    <span style="margin-left: 8px">销售价：</span>
                    <el-input-number v-model="item2.xsj" :disabled="optType == 'detail'" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                    <span style="margin-left: 8px">市场价：</span>
                    <el-input-number v-model="item2.scj" :disabled="optType == 'detail'" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                    <span style="margin-left: 8px">库存：</span>
                    <el-input-number v-model="item2.kc" :disabled="optType == 'detail'" :min="0" style="width: 180px; margin-right: 5px; margin-top: 10px"></el-input-number>
                    <el-button @click="deleteER(item, item2)" style="margin-left: 8px" :disabled="optType == 'detail'" type="danger"><i class="el-icon-delete"></i></el-button>
                  </div>
                  <!-- 规格图片上传 -->
                  <div style="margin-left: 8px">上传规格图片：</div>
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :multiple="true"
                    :file-list="item2.urlList"
                    list-type="picture-card"
                    :on-change="(file, fileList) => handleChange4(item2.urlList, file, fileList, index)"
                    :auto-upload="false"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="(file, fileList) => handleRemove4(item2.urlList, file, fileList, index)"
                    :limit="1"
                    :class="item2.urlList.length == 1 ? 'mf' : ''"
                    :disabled="optType == 'detail'"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <!--  -->
                </div>
              </div>
            </div>
            <el-button v-if="ruleForm.guigeList.length > 0" type="primary" :disabled="optType == 'detail'" style="margin-left: 8px; margin-top: 10px" @click="initTable">生成规格明细</el-button>
            <div v-if="ruleForm.guigeList.length > 0" class="table">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="name" label="规格值*规格值"> </el-table-column>
                <el-table-column prop="xsj" label="销售价(元)"> </el-table-column>
                <el-table-column prop="scj" label="市场价(元)"> </el-table-column>
                <el-table-column prop="kc" label="库存"> </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <div class="subtitle">
            <h4>其他</h4>
          </div>
          <el-form-item label="快递费：" :required="true">
            <!-- 9.16产品要求隐藏 -->
            <!-- <p>
                    <el-radio v-model="yf" label="1">统一运费</el-radio>
                    <span v-if="yf == '1'"><el-input-number placeholder="运费" v-model="yfprice" :min="0" style="width: 180px; margin-left: 8px; margin-right: 5px"></el-input-number>元</span>
                </p> -->
            <div class="flex">
              <el-radio v-model="yf" :label="1" :disabled="optType == 'detail'">包邮</el-radio>
              <el-input v-model="ruleForm.send_goods_time" :disabled="optType == 'detail'" style="width: 240px" clearable>
                <template slot="append">小时内发货</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="发货地址：" prop="warehouse_address_id" class="close" required>
            <el-select v-model="ruleForm.warehouse_address_id" :disabled="optType == 'detail'" multiple placeholder="请选择发货地址" clearable>
              <el-option v-for="item in warehouseList" :key="item.addressId" :label="item.province + item.city + item.area + item.addressDetail" :value="item.addressId">
                <!-- <span>{{item.province+item.city+item.area+item.addressDetail}}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否自动上架：" prop="put_on_sale">
            <el-radio-group v-model="ruleForm.put_on_sale" :disabled="optType == 'detail'">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <p style="font-size: 12px; color: #999">{{ ruleForm.put_on_sale == 1 ? "审核通过之后将自动上架" : "审核通过之后，需要在商品库中，手动上架" }}</p>
          </el-form-item>
          <el-form-item label="是否支持7天无理由退货:" prop="unconditional_return">
            <el-radio-group v-model="ruleForm.unconditional_return" :disabled="optType == 'detail'">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="否参与转赠：" prop="is_give">
            <el-radio-group v-model="ruleForm.is_give" :disabled="optType == 'detail'">
              <el-radio :label="1">参与</el-radio>
              <el-radio :label="0">不参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button :disabled="disabledOK" @click="quxiao">返 回</el-button>
            <el-button type="primary" @click="submitForm" :loading="disabledOK" v-show="optType != 'detail'">{{ optType == "add" ? "提交审核" : "保 存" }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <DeliveryAddress ref="refDeliveryAddress" @initOption="getOptionList"></DeliveryAddress>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DeliveryAddress from "./component/DeliveryAddress.vue";
import PropertyUnit from "./component/PropertyUnit.vue";
export default {
  name: "insert",
  data() {
    return {
      guigeImgList: [],
      prepertyList: [], // 商品参数列表  商品属性
      attribute: [],
      tipMsg: "",
      options: [
        {
          value: 0,
          label: "无"
        }
      ],
      ruleForm: {
        warehouse_address_id: [],
        send_goods_time: "",
        name: "",
        /*  region: "2000", //分类 */
        goods_brand_id: "",
        prolei: [], //商品分类
        zhuFile: [], //主图
        lbFile: [], //轮播图
        guigeList: [],
        xsj: undefined, //销售价
        scj: undefined, //市场价
        kc: undefined, //库存
        detailFile: [], //详情图
        image_main: "", //主图url
        img_detail: [], //轮播图url
        goods_detail_imgs_id: [], //详情图id
        put_on_sale: 1,
        unconditional_return: 1,
        attribute: [],
        shop_name: "",
        is_give: 0
      },
      titlesOk: true,
      deleteId: [],
      disabledOK: false,
      guititle: "", //规格名添加
      customers: [], //获取标品
      Guigename: [], //规格名列表
      ggname: "",
      ggvalue: "",
      Spec: "1", //规格(单或多)
      yf: 1, //运费
      yfprice: undefined, //运费价格
      dialogImageUrl: "",
      dialogVisible: false,
      // insertggm: false, //添加规格
      tableData: [],
      rules: {
        is_give: [
          {
            required: true,
            message: "请选择否参与转赠",
            trigger: "change"
          }
        ],
        send_goods_time: [
          {
            required: true,
            message: "请填写发货时间",
            trigger: "blur"
          }
        ],
        shop_name: [
          {
            required: true,
            message: "请选择店铺名称",
            trigger: "blur"
          }
        ],
        warehouse_address_id: [
          {
            required: true,
            message: "请选择发货地址",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            min: 0,
            max: 80,
            message: "商品名称不能超过80个字符",
            trigger: "blur"
          }
        ],
        zhuFile: [
          {
            required: true,
            message: "请上传主图"
          }
        ],
        lbFile: [
          {
            required: true,
            message: "请上传商品轮播图"
          }
        ],
        /*   region: [
            {
              required: true,
              message: "请选择分类类型",
              trigger: "blur",
            },
          ], */
        goods_brand_id: [
          {
            required: true,
            message: "请选择品牌类型",
            trigger: "blur"
          }
        ],
        prolei: [
          {
            required: true,
            message: "请选择商品分类",
            trigger: "blur"
          }
        ],
        xsj: [
          {
            required: true,
            message: "请填写销售价格",
            trigger: "blur"
          }
        ],
        scj: [
          {
            required: true,
            message: "请填写市场价",
            trigger: "blur"
          }
        ],
        kc: [
          {
            required: true,
            message: "请填写库存",
            trigger: "blur"
          }
        ],
        detailFile: [
          {
            required: true,
            message: "请上传商品详情图",
            trigger: "blur"
          }
        ],
        guigeList: [
          {
            required: true,
            message: "请填写商品规格",
            trigger: "blur"
          }
        ],
        put_on_sale: [
          {
            required: true,
            message: "请选择是否自动上架",
            trigger: "change"
          }
        ],
        unconditional_return: [
          {
            required: true,
            message: "请选择是否支持7天无理由退货",
            trigger: "change"
          }
        ]
      },
      timer: null,
      loading: false,
      warehouseList: [],
      optType: "",
      shop_opt: [],
      shop_opt1: [],
      params_opt: [],
      params_load: false,
      params_arr: [],
      params_id: "",
      selParams_opt: [],
      attributeList: [],
      sen_ID: "",
      product_id: ""
    };
  },
  created() {
    /**@param {获取店家申请店铺 getShopList} */
    this.getShopList();
    this.getOptionList();
    // this.bindName();
    this.optType = this.$route.query.type;
    switch (this.optType) {
      case "add":
        break;
      case "edit":
        this.ids = this.$route.query.id;
        this.Bind();
        break;
      case "detail":
        this.ids = this.$route.query.id;
        this.Bind();
        break;
      default:
        break;
    }
  },
  mounted() {},
  watch: {},
  props: {},
  components: {
    DeliveryAddress,
    PropertyUnit
  },
  methods: {
    ...mapActions({
      getshopIdName: "newshop/getshopIdName", //发布商品获取商家店铺
      getshopstandardName: "newshop/getshopstandardName", //获取标品
      getshopbrand: "newshop/getshopbrand", //获取品牌
      getshopproperty: "newshop/getshopproperty", //获取属性
      saveProductGg: "newshop/saveProductGg", // 批量保存商品sku规格
      getProDetails: "newshop/getshopdetails", //详情
      getJudeGood: "newshop/getJudeGood", // 判断商品
      productPreAduit: "commodity/productPreAduit", // 判断商品存入状态

      getGoodLei: "commodity/getGoodLei",
      uploadFile: "commodity/uploadFile",
      getGuiNameList: "commodity/getGuiNameList",
      insertGuiName: "commodity/insertGuiName",
      proUpdate: "commodity/proUpdate",
      insertGoods: "commodity/insertGoods",
      insertGuige: "commodity/insertGuige",

      getGuiDetails: "commodity/getGuiDetails",
      getGoodsList: "commodity/newGoodsList",

      getWarehouseList: "commodity/getWarehouseList",

      argumentsName: "detect/argumentsName",
      selectMerchantShop: "detect/selectMerchantShop", // 选择商品店铺
      storeCageter: "detect/storeCageter"
    }),
    /**@param {获取标品-getshopstandardName} */
    shpoChange(item) {
      this.leixChange();
    },
    leixChange() {
      this.customers = [];
      this.getSearchData("");
      this.getshopstandardName({
        token: this.$store.state.token,
        shop_id: this.ruleForm.shop_name
      }).then(res => {
        if (res.code == 1) {
          this.customers = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cateChange(val) {
      if (!this.ruleForm.shop_name) {
        return;
      }
      let standard_id = val;
      let id = this.optType == "edit" ? this.ruleForm.id : 0;
      this.leixChange();
      this.init_getshopproperty(standard_id, id);
      this.bindName();
    },
    /**@param {获取参数getshopproperty} 商品属性 */
    init_getshopproperty(standard_id, goods_id) {
      let params = {
        token: this.$store.state.token,
        standard_id: standard_id,
        goods_id: goods_id ? goods_id : 0,
        sku_flag: 0 // 查商品属性
      };
      this.getshopproperty(params).then(res => {
        this.prepertyList = res.data;
        this.attribute = this.prepertyList.map(item => {
          return {
            property_id: "",
            property_name: item.name,
            value_id: "",
            value_name: "",
            unit_id: "",
            unit_name: "",
            unit: item.unit
          };
        });
      });
    },
    /**@param {获取店家申请店铺 getShopList} */
    getShopList() {
      let params = {
        token: this.$store.state.token
      };
      this.getshopIdName(params).then(res => {
        if (res.code == 1) {
          this.shop_opt = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    showDeliveryAddress() {
      this.$refs.refDeliveryAddress.dialogVisible = true;
      this.$refs.refDeliveryAddress.getList();
    },
    getOptionList() {
      let params = {
        merchantId: this.$getSessionStorage("userid"),
        deliveryPointState: 1
      };
      this.getWarehouseList(params).then(res => {
        if (res.code == 10000) {
          this.warehouseList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**@param { 品牌名称} */
    getSearchData(query) {
      let params = {
        name: query,
        shop_id: this.ruleForm.shop_name,
        token: this.$store.state.token
      };
      this.getshopbrand(params).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.options = res.data.map(item => {
            return {
              value: item.brand_id,
              label: item.name
            };
          });
          if (this.options.length == 0) {
            this.options.push({
              value: 0,
              label: "无"
            });
          }
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getSearchData(query);
        /*   if (this.timer) {
            clearTimeout(this.timer);
          } */
        /*   this.timer = setTimeout(() => {
            this.getSearchData(query);
          }, 800); */
      } else {
        this.options = [
          {
            value: 0,
            label: "无"
          }
        ];
      }
    },
    Bind() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.getProDetails({
        token: this.$store.state.token,
        id: this.ids
      })
        .then(res => {
          loading.close();
          if (res.code == 1) {
            this.product_id = res.data.id;
            this.ruleForm.attribute = res.data.spu_property_list;
            this.ruleForm.shop_name = res.data.shop_id; //商家名称
            this.ruleForm.id = res.data.id; // 商品id
            //轮播图images_circulate
            let a = res.data.images_circulate;
            for (let i = 0; i < a.length; i++) {
              this.ruleForm.lbFile.push({
                url: a[i]
              });
              this.ruleForm.img_detail.push({
                file: "1",
                url: a[i]
              });
            }
            //详情图
            let b = res.data.img_detail;
            for (let i = 0; i < b.length; i++) {
              this.ruleForm.detailFile.push({
                url: b[i]
              });
              this.ruleForm.goods_detail_imgs_id.push({
                file: "1",
                url: b[i]
              });
            }
            //快递费
            this.yf = res.data.is_express;
            this.ruleForm.send_goods_time = res.data.send_goods_time;
            //发货地址
            this.ruleForm.warehouse_address_id = res.data.warehouse_list.map(item => {
              return item.warehouse_id;
            });
            this.getOptionList();
            //自动上架
            this.ruleForm.put_on_sale = Number(res.data.put_on_sale);
            //7天无理由
            this.ruleForm.unconditional_return = Number(res.data.is_unconditional_return);
            //是否转增
            this.ruleForm.is_give = Number(res.data.is_give);
            // this.ruleForm.region = res.data.classifys_type_id;
            //  console.log(res.data.attribute);
            //   res.data.attribute.forEach((item) => {
            //     this.params_arr.push({ label: item.arguments_name, value: item.value, id: item.arguments_id, edit_id: item.id });
            //   });
            this.ruleForm.prolei = res.data.standard_id;
            this.customers.push({
              value: res.data.standard_id,
              label: res.data.standard_name
            });
            this.ruleForm.goods_brand_id = res.data.goods_brand_id || 0;
            if (res.data.goods_brand_id > 0) {
              this.options.push({
                value: res.data.goods_brand_id,
                label: res.data.brand_name
              });
            } else {
              this.options = [
                {
                  value: 0,
                  label: "无"
                }
              ];
            }

            this.ruleForm.name = res.data.name;
            this.ruleForm.image_main = res.data.image_main;
            this.ruleForm.zhuFile = [
              {
                url: res.data.image_main
              }
            ];

            // 获取店铺id
            this.getShopList();

            this.getshopstandardName({
              token: this.$store.state.token,
              shop_id: res.data.shop_id
            })
              .then(res => {
                if (res.code == 1) {
                  this.customers = res.data;
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch(err => {
                console.log(err);
              });

            let part = [];
            res.data.sku_data.length &&
              res.data.sku_data.forEach((item, index) => {
                this.tableData.push({
                  id: item.id,
                  name: item.sku_name,
                  xsj: item.price_sell,
                  scj: item.price_market,
                  kc: item.merchandise_inventory,
                  url: item.img_url,
                  property_id: item.property_list[0].property_id,
                  property_name: item.property_list[0].property_name,
                  property_id2: item.property_list[1] ? item.property_list[1].property_id : 0,
                  property_name2: item.property_list[1] ? item.property_list[1].property_name : "默认值"
                });
                this.guigeImgList.push({
                  url: item.img_url
                });
                let arr2 = item.sku_name.split(",");
                if (part.indexOf(arr2[0])) {
                  part.push(arr2[0]);
                }
              });
            part.forEach((p, index) => {
              this.ruleForm.guigeList.push({
                value: "",
                ggname: "",
                gg2name: "",
                gg2value: "",
                children2: []
              });
              let child = [];
              res.data.sku_data.length &&
                res.data.sku_data.forEach(item => {
                  if (item.sku_name.indexOf(p) > -1) {
                    this.ruleForm.guigeList[index].value = item.property_list[0].value_name;
                    this.ruleForm.guigeList[index].ggname = item.property_list[0].property_id + "";
                    this.ruleForm.guigeList[index].gg2name = item.property_list[1] ? item.property_list[1].property_id : "";
                    /*    this.ruleForm.guigeList[index].gg2name = item.property_list[1].property_id + ''; */
                    this.ruleForm.guigeList[index].gg2value = item.property_list[1] ? item.property_list[1].value_name : "";
                    let arr = item.property_list[1] ? item.property_list[1] : [];
                    let obj = {
                      id: arr.id ? arr.id : "",
                      shop_p_id: item.id,
                      name: arr.property_id ? arr.property_id : "",
                      value: arr.value_name ? arr.value_name : "",
                      xsj: item.price_sell,
                      scj: item.price_market,
                      kc: item.merchandise_inventory,
                      urlList: [
                        {
                          url: item.img_url
                        }
                      ]
                    };
                    child.push(obj);
                  }
                });
              this.ruleForm.guigeList[index].children2 = child;
            });
            //商品标准名称：
            if (this.ruleForm.shop_name) {
              /*   this.leixChange(); */
              this.init_getshopproperty(res.data.standard_id, res.data.id);
              // this.init_getshopproperty(97, 1)
              this.bindName();
            }
            //品牌名称
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
        });
    },
    submitForm2() {
      return new Promise((resolve, reject) => {
        if (this.optType == "edit") {
          this.$confirm("请确认是否修改商品规格，如已修改，请确认是否已重新生成规格表，否则更改不生效", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              resolve();
            })
            .catch(() => {});
        } else {
          resolve();
        }
      });
    },
    submitForm() {
      // return
      this.submitForm2().then(_ => {
        // if (!this.titlesOk) this.$message.warning("商品名称重复，请更改");
        this.$refs["ruleForm"].validate(valid => {
          let k = true;
          if (this.ruleForm.guigeList.length > 0 && this.ruleForm.guigeList[0].children2.length <= 0) {
            this.$message.warning("请填写规格！");
            k = false;
          }

          if (this.tableData.length <= 0) {
            this.$message.warning("请先生成规格表！");
            k = false;
          }

          if (valid && k) {
            this.disabledOK = true;
            let detal = [];
            for (let i = 0; i < this.ruleForm.goods_detail_imgs_id.length; i++) {
              detal.push(this.ruleForm.goods_detail_imgs_id[i].id);
            }
            let lb = [];
            for (let i = 0; i < this.ruleForm.img_detail.length; i++) {
              lb.push(this.ruleForm.img_detail[i].url);
            }
            let img_urls = this.ruleForm.goods_detail_imgs_id.map(item => {
              return item.url;
            });
            let data = {
              token: this.$store.state.token,
              name: this.ruleForm.name, //商品名称
              standard_id: this.ruleForm.prolei, //商品标准库id
              goods_brand_id: this.ruleForm.goods_brand_id, //商品品牌id
              shop_id: this.ruleForm.shop_name, //店铺id
              is_unconditional_return: 1, //无理由退货  1 支持 0 不支持
              image_main: this.ruleForm.image_main, //商品主图
              images: lb.join(","), //商品轮播图， 多张用逗号分割
              img_urls: img_urls.join(","), //商品详情图， 多张用逗号分割
              put_on_sale: this.ruleForm.put_on_sale, //是否自动上下架  0 不是 1是
              is_give: this.ruleForm.is_give, //是否转增  0 不转正  1转正
              is_express: this.yf, //是否包邮 0 不包  1 包
              warehouse_address_ids: this.ruleForm.warehouse_address_id, // this.ruleForm.warehouse_address_id  发货仓库地址id
              send_goods_time: this.ruleForm.send_goods_time, //付款后，多长时间发货（单位：时）
              attribute: this.attribute
            };

            if (parseInt(this.Spec) == 1) {
              data.merchandise_inventory = this.ruleForm.kc;
            }
            if (parseInt(this.yf) == 1) data.is_express_price = this.yfprice; //快递费费用
            let url;
            if (this.optType == "add") {
              url = this.insertGoods;
            } else if (this.optType == "edit") {
              url = this.proUpdate;
              data.id = this.$route.query.id;
            }
            url(data)
              .then(res => {
                this.disabledOK = false;
                if (res.code == 1) {
                  this.product_id = res.data.id ? res.data.id : this.$route.query.id;
                  let opt = {
                    token: this.$store.state.token,
                    id: this.optType == "edit" ? this.$route.query.id : res.data.id,
                    list: []
                  };
                  for (let i = 0; i < this.tableData.length; i++) {
                    let arr = null;
                    if (this.tableData[i].name.indexOf("*") >= 0) {
                      arr = this.tableData[i].name.split("*");
                    } else {
                      arr = this.tableData[i].name.split(",");
                    }
                    let obj1 = {
                      property_id: this.tableData[i].property_id,
                      property_name: this.tableData[i].property_name,
                      value_id: "",
                      value_name: arr[0].indexOf(":") >= 0 ? arr[0].split(":")[1].trim() : arr[0]
                    };
                    let obj2 = {
                      property_id: this.tableData[i].property_id2,
                      property_name: this.tableData[i].property_name2,
                      value_id: "",
                      value_name: arr[1] == undefined ? "默认值" : arr[1].indexOf(":") >= 0 ? arr[1].split(":")[1].trim() : arr[1]
                    };
                    let id = this.tableData[i].shop_p_id ? this.tableData[i].shop_p_id : "";
                    let obj3 = {
                      price_sell: this.tableData[i].xsj,
                      price_market: this.tableData[i].scj,
                      merchandise_inventory: this.tableData[i].kc,
                      img_url: this.tableData[i].url,
                      property_list: [obj1, obj2]
                    };
                    if (this.optType == "edit" && id) {
                      obj3.id = id;
                    }
                    opt.list.push(obj3);
                  }
                  this.saveProductGg(opt).then(msg => {
                    if (msg.code == 1) {
                      this.getJudeGood({
                        goodsId: this.product_id
                      }).then(res => {
                        if (res.judgeresult == 1) {
                          this.get_productPreAduit(res.judgeresult, "", 1);
                        } else {
                          this.$message.warning({
                            message: `${res.message},请重新编辑！`,
                            duration: 5000
                          });
                          this.get_productPreAduit(res.judgeresult, res.message, 0);
                          /* this.$router.push("/home/commodity");
                             this.$router.push(`/home/goodsOpeation?type=edit&id=${this.product_id}`); */
                        }
                        /*  this.$message.success(this.optType == "add" ? "添加成功!" : "编辑成功！");
                          this.$message.warning({
                            message: res.message,
                            duration: 2000
                          }) */
                        /* this.$router.push("/home/commodity"); */
                      });
                    } else {
                      this.$message.error(msg.msg);
                    }
                  });
                } else {
                  this.disabledOK = false;
                  this.$message.error(res.msg);
                }
              })
              .catch(err => {
                this.disabledOK = false;
                this.$message.error(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    // 预审核存状态
    get_productPreAduit(standard_status, standard_reason, keys) {
      let params = {
        token: this.$store.state.token,
        id: this.product_id,
        standard_status: standard_status, //预审状态  1 成功  0失败
        standard_reason: standard_reason //预审异常原因
      };
      this.productPreAduit(params).then(res => {
        if (res.code == 1) {
          if (keys == 1) {
            this.$router.push("/home/commodity");
          } else {
            this.$router.push(`/home/goodsOpeation?type=edit&id=${this.product_id}`);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    quxiao() {
      this.$router.push("/home/commodity");
    },
    getGuival(val) {
      for (let i = 0; i < this.Guigename.length; i++) {
        if (this.Guigename[i].id == val) {
          return this.Guigename[i].title;
        }
      }
    },
    // 获取商品规格列表
    bindName() {
      let params = {
        token: this.$store.state.token,
        standard_id: this.ruleForm.prolei,
        goods_id: 0,
        sku_flag: 1 // 查商品规格
      };
      this.getshopproperty(params).then(res => {
        if (res.code == 1) {
          let { data } = res;
          this.Guigename = data.map(item => {
            return {
              id: item.property_id,
              title: item.name
            };
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initTable() {
      let isTrue = true;
      let imgTrue = true;
      let list = this.ruleForm.guigeList;
      console.log("list :>> ", list);
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].children2.length; j++) {
          if (list[i].children2[j].kc == 0) {
            isTrue = false;
          }
          if (list[i].children2[j].scj == 0) {
            isTrue = false;
          }
          if (list[i].children2[j].xsj == 0) {
            isTrue = false;
          }

          if (list[i].children2[j].urlList.length == 0) {
            imgTrue = false;
          }
        }
      }
      if (!isTrue) {
        this.$message.error("请填写完整的价格！");
        return false;
      }
      // for(let i = 0; i < list.length; i++) {
      //   if (list[i].urlList.length < 1) {
      //     imgTrue = false;
      //   }
      // }
      if (!imgTrue) {
        this.$message.error("每个规格都需要添加图片！");
        return false;
      }
      // if (this.ruleForm.guigeList.length != this.guigeImgList.length) {
      //   this.$message.error('每个规格都需要添加图片！')
      //   return false;
      // }
      this.tableData.splice(0, this.tableData.length);
      for (let i = 0; i < this.ruleForm.guigeList.length; i++) {
        // 规格名1
        let preperty_Index1 = this.Guigename.findIndex(item => {
          return item.id == this.ruleForm.guigeList[i].ggname;
        });
        // 规格名2
        let preperty_Index2 = this.Guigename.findIndex(item => {
          return item.id == this.ruleForm.guigeList[i].gg2name;
        });
        /**
         * 单规格商品
         */
        if (this.ruleForm.guigeList[i].gg2name == 0) {
          for (let j = 0; j < this.ruleForm.guigeList[i].children2.length; j++) {
            this.tableData.push({
              property_id: this.Guigename[preperty_Index1].id,
              property_name: this.Guigename[preperty_Index1].title,
              property_id2: 0,
              property_name2: "默认值",
              name: this.ruleForm.guigeList[i].value,
              xsj: this.ruleForm.guigeList[i].children2[j].xsj,
              scj: this.ruleForm.guigeList[i].children2[j].scj,
              kc: this.ruleForm.guigeList[i].children2[j].kc,
              url: this.ruleForm.guigeList[i].children2[j].urlList[0].url,
              shop_p_id: this.ruleForm.guigeList[i].children2[j].shop_p_id
            });
          }
        } else {
          /**
           * 多规格商品
           */
          for (let j = 0; j < this.ruleForm.guigeList[i].children2.length; j++) {
            this.tableData.push({
              property_id: this.Guigename[preperty_Index1].id,
              property_name: this.Guigename[preperty_Index1].title,
              property_id2: this.Guigename[preperty_Index2].id,
              property_name2: this.Guigename[preperty_Index2].title,
              name: this.ruleForm.guigeList[i].value + "*" + this.ruleForm.guigeList[i].children2[j].value,
              xsj: this.ruleForm.guigeList[i].children2[j].xsj,
              scj: this.ruleForm.guigeList[i].children2[j].scj,
              kc: this.ruleForm.guigeList[i].children2[j].kc,
              url: this.ruleForm.guigeList[i].children2[j].urlList[0].url,
              shop_p_id: this.ruleForm.guigeList[i].children2[j].shop_p_id
            });
          }
        }
      }
    },
    // insertGgm () {
    //   this.insertGuiName({
    //     token: this.$store.state.token, //必填  商户登录后的token
    //     title: this.guititle, //必填 规格名称
    //   }).then((res) => {
    //     if (res.code == 1) {
    //       this.bindName();
    //       this.$message.success("添加成功");
    //       this.guititle = "";
    //       this.insertggm = false;
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    insertYI() {
      if (this.ggname != "" && this.ggvalue != "") {
        let a = "";
        let kg = 0;
        for (let i = 0; i < this.ruleForm.guigeList.length; i++) {
          if (this.ruleForm.guigeList[i].ggname == this.ggname) {
            a = this.ruleForm.guigeList[i].gg2name;
            kg = 1;
          }
        }
        if (kg == 1) {
          //代表之前添加过
          let items = this.ruleForm.guigeList[this.ruleForm.guigeList.length - 1];
          // console.log(items, "items");
          if (items.children2.length > 0) {
            //判断上一个房间里面的值
            this.ruleForm.guigeList.push({
              ggname: this.ggname, //规格名id
              value: this.ggvalue, //规格值
              gg2name: a,
              gg2value: "",
              namein: "",
              urlList: [],
              children2: []
            });
          }
        } else {
          this.ruleForm.guigeList.push({
            ggname: this.ggname,
            value: this.ggvalue,
            gg2name: a,
            gg2value: "",
            namein: "",
            urlList: [],
            children2: []
          });
        }

        this.ggvalue = "";
      } else {
        this.$message.warning("请填写规格名称！");
      }
    },
    insertER(item) {
      if (item.gg2name != "" && item.gg2value != "") {
        item.children2.push({
          id: 0,
          name: item.gg2name,
          value: item.gg2value,
          xsj: "",
          scj: "",
          kc: "",
          urlList: []
        });
        item.gg2value = "";
      } else if (item.gg2name == 0) {
        item.children2.push({
          id: 0,
          name: item.value,
          value: item.value,
          xsj: "",
          scj: "",
          kc: "",
          urlList: []
        });
      }
    },
    deleteers(item) {
      for (let i = 0; i < item.children2.length; i++) {
        if (item.children2[i].id != 0) {
          this.deleteId.push(item.children2[i].id);
        }
      }
      item.children2.splice(0, item.children2.length);
    },
    deleteER(item, child) {
      if (child.id != 0) this.deleteId.push(child.id);
      item.children2.splice(item.children2.indexOf(child), 1);
    },
    deleteYI(item) {
      for (let i = 0; i < item.children2.length; i++) {
        if (item.children2[i].id != 0) {
          this.deleteId.push(item.children2[i].id);
        }
      }
      this.ruleForm.guigeList.splice(this.ruleForm.guigeList.indexOf(item), 1);
      this.tableData = [];
    },
    handleChange1(file, fileList) {
      console.log("file :>> ", file);
      var formdata = new FormData();
      formdata.append("img", file.raw);
      this.ruleForm.zhuFile = fileList;
      this.uploadFile(formdata).then(res => {
        if (res.code == 200) {
          this.$message.success("上传成功！");
          this.ruleForm.image_main = res.data;
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    handleChange2(file, fileList) {
      var formdata = new FormData();
      formdata.append("img", file.raw);
      this.ruleForm.lbFile = fileList;
      this.uploadFile(formdata).then(res => {
        if (res.code == 200) {
          this.$message.success("上传成功！");
          this.ruleForm.img_detail.push({
            file: file,
            url: res.data
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    handleRemove1(file, fileList) {
      this.ruleForm.zhuFile = this.ruleForm.zhuFile.filter(item => {
        return item != file;
      });
    },
    handleRemove2(file, fileList) {
      this.ruleForm.img_detail = this.ruleForm.img_detail.filter(item => {
        if (item.file == "1") {
          return item.url != file.url;
        } else return item.file != file;
      });
    },
    handleChange3(file, fileList) {
      var formdata = new FormData();
      formdata.append("img", file.raw);
      this.ruleForm.detailFile = fileList;
      this.uploadFile(formdata).then(res => {
        if (res.code == 200) {
          this.$message.success("上传成功！");
          this.ruleForm.goods_detail_imgs_id.push({
            file: file,
            url: res.data
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    // 规格图片上传
    handleChange4(urlList, file, fileList, index) {
      var formdata = new FormData();
      formdata.append("img", file.raw);
      // this.ruleForm.guigeImgList = fileList;
      this.uploadFile(formdata).then(res => {
        if (res.code == 200) {
          this.$message.success("上传成功！");
          urlList.push({
            file: file,
            url: res.data
          });
          // this.guigeImgList[index]={
          //   file: file,
          //   url: res.data.formdata_details[0].urls,
          // };
          /*  this.guigeImgList.push({
             file: file,
             url: res.data.formdata_details[0].urls,
           }); */
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    handleRemove4(urlList, file, fileList, index) {
      urlList.splice(0, 1);
      //  this.guigeImgList.splice(this.guigeImgList.indexOf(file), 1)
      /*   this.guigeImgList = this.guigeImgList.filter((item) => {
          if (item.file == "1") {
            return item.url != file.url;
          } else return item.file != file;
        }); */
    },
    handleRemove3(file, fileList) {
      this.ruleForm.goods_detail_imgs_id = this.ruleForm.goods_detail_imgs_id.filter(item => {
        if (item.file == "1") {
          return item.url != file.url;
        } else return item.file != file;
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  min-width: 1200px;
  margin: 20px;
}

.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 18px;
  color: #333;
  width: 100%;
  padding: 15px 32px;
}

.demo-ruleForm {
  margin: 40px;
}

.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}

.bg {
  padding: 24px;
  padding-bottom: 4px;
  background: #f5f5f5;

  & > .el-row {
    margin: 0;

    .el-col {
      height: 36px;
      line-height: 36px;
      margin-bottom: 20px;
      text-align: right;

      label {
        padding-right: 14px;
        display: inline-block;
      }
    }
  }
}

::v-deep .close .el-input__validateIcon {
  display: none !important;
}

.subtitle {
  &:first-child {
    margin-top: 0;
  }

  margin: 35px 0;
  display: flex;
  align-items: center;

  h4 {
    padding-left: 20px;
    line-height: 18px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333333;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 2px;
      background: #2448ff;
    }
  }
}
</style>
